import React, { useEffect, useState } from 'react';

import Spinner from '@components/Spinner';
import { type ReporterLookup, fetchReportersByName } from '@utils/backend-api/subscriber_directory';

import ReporterCard from './ReporterCard';
import MyTISection from './Section';

interface MyTIReportersProps {
  recommendedAuthors: string[];
}

const MyTIReporters = ({ recommendedAuthors }: MyTIReportersProps) => {
  const [reporters, setReporters] = useState<ReporterLookup[]>([]);

  useEffect(() => {
    // TODO FIXME Need to use the real recommended authors
    const recommendedAuthors = ['Yueqi Yang', 'Katie Roof', 'Theo Wayt'];
    if (!recommendedAuthors?.length) return;

    let cancelled = false;
    fetchReportersByName(recommendedAuthors).then((data) => {
      if (!cancelled) setReporters(data);
    });

    return () => {
      cancelled = true;
    };
  }, [recommendedAuthors]);

  return (
    <MyTISection highlight="Label" subtitle="The people behind the bylines" title="Reporters">
      <div className="flex flex-row flex-wrap gap-32 md:gap-64 *:md:max-w-[374px] lg:flex-nowrap">
        {reporters?.length ? (
          reporters.map((reporter) => <ReporterCard key={reporter.id} reporter={reporter} />)
        ) : (
          <Spinner marginY="small" />
        )}
      </div>
    </MyTISection>
  );
};

export default MyTIReporters;
